import styled from 'styled-components';

export const CostsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1% 3%;
    font-size: 1rem;
    align-items: flex-start;
    justify-content: space-between;
    margin: 10px 0;
    padding-bottom: 50px;
    text-align: left;

    @media only screen and (max-width: 600px) {
        align-items: center;
        width: 100%;
    }
`;

export const CostsSubTitle = styled.h2`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    stroke: bold;
`;

export const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;

export const LowPowerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: center;
    justify-content: center;
    padding: 10px 20px;
    border-radius: 5px;
    background-color: ${props => props.theme.ecoMint};
    width: 25%;
    min-width: 350px;
    height: 100%;
    border: 1px solid ${props => props.theme.voltBlue};

    @media only screen and (max-width: 1024px) {
        width: 90%;
        margin-top: 20px;
        min-width: unset;
    }
`;

export const LargeRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    @media only screen and (max-width: 1024px) {
        flex-direction: column;
    }
`;